module.exports = __webpack_public_path__ + "img/sort.8218a43e.svg";